import legacyTheme from 'components/Legacy/theme'
import palette from 'components/palette'

import { ThemeType } from './types'

const borderRadius = '0.25rem'
const tradeTicket = 18.75
const nonChartWidth = 18.75 * 2

const theme: ThemeType = {
  ...legacyTheme,
  baseFontSize: '16px',
  buttonBorderRadius: borderRadius,
  buttonSizes: {
    lg: '3rem',
    md: '2.5rem',
    sm: '2rem'
  },
  dangerColor: palette.red600,
  fontPrimary:
    '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;',
  fontSizes: {
    hg: '2rem',
    lg: '1.125rem',
    md: '1rem',
    ms: '0.625rem',
    sm: '0.875rem',
    xl: '1.25rem',
    xs: '0.75rem',
    xxl: '1.5rem'
  },
  iconColor: palette.white,
  inputBorderRadius: borderRadius,
  inputColor: palette.black,
  inputSizes: {
    lg: '3.5rem',
    md: '3rem',
    sm: '1.5rem'
  },
  linkColor: palette.white,
  palette,
  screenWidth: {
    lg: '999rem',
    md: '62rem',
    sm: '48rem',
    xs: '30rem'
  },
  sectionSizes: {
    nonChartWidth: `${nonChartWidth}rem`,
    orderBookCompact: '42rem',
    tradeTicket: `${tradeTicket}rem`,
    widget: `${tradeTicket + 1}rem`,
    widgetContainerLg: '100%',
    widgetContainerSm: '100%',
    widgetHeader: '2rem',
    widgetHeaderCompact: '3rem'
  },
  successColor: palette.green600,
  textColor: palette.white,
  transition: {
    fast: '150ms',
    medium: '300ms',
    slow: '1000ms'
  },
  widgetBorderColor: palette.dark800,
  widgetBorderWidth: '1px',
  zIndex: [1, 10, 20, 30, 40, 50, 60]
}

export default theme
